import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './slices/authSlice';
import appSourcesReducer from './slices/appSourcesSlice';
import defaultFareReducer from './slices/defaultFareSlice';
import transactionReportsReducer from './slices/transactionReportsSlice';
import auditTrailReducer from './slices/auditTrailSlice';
import transactionLogsReducer from './slices/transactionLogsSlice';
import dashboardReducer from './slices/dashboardSlice';
import dailyReportsReducer from './slices/dailyReportsSlice';
import uniqueUsersReducer from './slices/uniqueUsersSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth']
};

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  dailyReports: dailyReportsReducer,
  uniqueUsers: uniqueUsersReducer,
  appSources: appSourcesReducer,
  defaultFares: defaultFareReducer,
  transactionReports: transactionReportsReducer,
  auditTrail: auditTrailReducer,
  transactionLogs: transactionLogsReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
});

export const persistor = persistStore(store);

export default store;
